import { PencilSimpleLine } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";

import ResetTargeting from "../ResetTargeting";

export default function ResetTargetingButton({
  isDisabled,
}: {
  isDisabled: boolean;
}) {
  const [isResetTargetingOpen, setIsResetTargetingOpen] = useState(false);

  return (
    <>
      <Button
        variant="secondary-black"
        intent="iconOnly"
        disabled={isDisabled}
        onClick={() => setIsResetTargetingOpen(true)}
      >
        <PencilSimpleLine />
      </Button>
      <ResetTargeting
        isOpen={isResetTargetingOpen}
        setIsOpen={setIsResetTargetingOpen}
      />
    </>
  );
}
